export default __webpack_public_path__ + "static/media/gallery3.fe35ff56.jpg";